<template>
  <div class="multi-search-range flexC mr-8">
    <cube-input-number   v-model="min"  v-bind="config" placeholder="最小值" style="width: 92px" />
    <div class="line"></div>
    <cube-input-number
      v-model="max"
      placeholder="最大值"
      style="width: 92px"
      v-bind="config"
      class="mr-8"
    />
    <cube-button
:disabled="!min && !max"
plain
@click="confirm"
      >确定</cube-button
    >
  </div>
</template>
<script>
export default {
  props: {
    parent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      min: '',
      max: ''
    }
  },
  computed: {
    config() {
      return this.parent.config ? this.parent.config : {}
    }
  },
  methods: {
    confirm() {
      const { unit } = this.parent
      const u = unit || ''
      const { min, max } = this
      let label = ''
      let value = null
      if (min && max) {
        label = `${min}${u}以上,${max}${u}以下`
      } else if (min && !max) {
        label = `${min}${u}以上`
      } else if (!min && max) {
        label = `${max}${u}以下`
      }
      value = { min, max }
      this.$emit('confirm', this.parent, { label, value }, 'range')
      this.min = ''
      this.max = ''
    }
  }
}
</script>
<style scoped lang="scss">
.line {
  margin: 0 2px;
  width: 12px;
  height: 1px;
  background: #dee1e8;
}
</style>
